export default __webpack_public_path__ + "static/media/loading.db5a61bc.svg";